/* global restObject */
import axios from 'axios';

export const submit = (state, form) => {
    return axios.post(
        state.submitEndpoint,
        form,
        {
            headers: {
                'X-WP-Nonce': restObject.restNonce,
                'X-api-key': state.apiKey,
                'Content-Type': 'multipart/form-data'
            },
        } 
    ).then(response => {
        return response.data;
    }).catch(err => {
        // eslint-disable-next-line
        console.error(err);
    })
};

export const getCategories = (state) => {
    return axios.get(
        state.categoriesEndpoint + '?operation=' + state.operation, 
        {
            headers: {
                'X-WP-Nonce': restObject.restNonce,
                'X-api-key': state.apiKey,
            }
        }
    ).then(response => {
        return response.data
    }).catch(err => {
        // eslint-disable-next-line
        console.log(err);
    })
}